export default {
  "dot": "_dot_3rewq_1",
  "disabled": "_disabled_3rewq_7",
  "upgrade": "_upgrade_3rewq_11",
  "success": "_success_3rewq_15",
  "warning": "_warning_3rewq_19",
  "danger": "_danger_3rewq_23"
};import "ni:sha-256;t5gJmHlOqbq0d6x-XdJr64s0jrtXPtvum8I1HOPNEmI";